import React, { Component } from "react";
import { connect } from "react-redux";
import {
  hidePopUp,
  DecrementCountDown,
  logoutSessionFlush
} from "../../actions/globalActions";
import {
  CustomModal,
  ModalHeading,
  ExpirePara,
  SecondCount,
  ButtonWrapper,
  Ahref,
  Button
} from "./style";
import { DataHeading } from "../commonStyles";
import PropTypes from "prop-types";
import { recordError } from "../../utils/commonUtil";
import { timerModalCountDown } from "../../selectors/globalSelectors";
import { logOut } from '../../Auth0/SessionProvider';
import { isGeminiUser, getAccountData } from '../../utils/sessionUtil';

class TimerModal extends Component {
  state = {
    isLogout: false,
    isOpen: false
  };

  componentDidMount() {
    this.setState({
      isOpen: true
    });
    return (this.timeRemaining = setInterval(() => {
      return this.props.DecrementCountDown();
    }, 1000));
  }

  componentWillUnmount() {
    return clearInterval(this.timeRemaining);
  }

  handleContinue = () => {
    this.props.hidePopUp();
    this.setState({
      isOpen: false
    });
  };

  handleLogout = () => {
    try {
      this.setState({
        isLogout: true,
        isOpen: false
      });
      this.props.hidePopUp();
      if(isGeminiUser()) {        
        this.props.logoutSessionFlush({
          method: "POST",
          url: `/donor-portal/api/party/${
            getAccountData().partyId
          }/revokeAccessToken`,
          page: "sessionTimeOut"
        });
      } else {
        logOut('sessionTimeOut');
      }
    } catch (error) {      
      recordError(error);
    }
  };

  hide = () => {
    this.props.hidePopUp();
    if(isGeminiUser()) {
      this.props.logoutSessionFlush({
        method: "POST",
        url: `/donor-portal/api/party/${
          getAccountData().partyId
        }/revokeAccessToken`,
        page: "WarningPopUp"
      });
    } else {
      logOut('WarningPopUp');
    }
    return "";
  };

  renderModal() {
    return (
      <CustomModal
        title={[<ModalHeading>Session Timeout Warning</ModalHeading>]}
        visible={true}
        onCancel={this.handleLogout}
        footer={[]}
        maskClosable={false}
      >
        <DataHeading>
          <ExpirePara>
            We’ve noticed you’ve been away for some time. You will be
            automatically signed out in
          </ExpirePara>
          <SecondCount>
            {this.props.countDown >= 0
              ? this.props.countDown + " seconds"
              : this.hide()}
          </SecondCount>
          <ExpirePara>Do you want to stay logged in?</ExpirePara>
        </DataHeading>
        <ButtonWrapper>
          <Button onClick={this.handleContinue}>Yes, keep me signed in</Button>
          <Ahref onClick={this.handleLogout}>Log Out</Ahref>
        </ButtonWrapper>
      </CustomModal>
    );
  }
  render() {
    return (
      <div>
        <div>{this.renderModal()}</div>
      </div>
    );
  }
}

TimerModal.propTypes = {
  DecrementCountDown: PropTypes.func,
  countDown: PropTypes.number,
  hidePopUp: PropTypes.func,
  logoutSessionFlush: PropTypes.func
};

export const mapStateToProps = state => {
  return {
    countDown: timerModalCountDown(state.toJS())
  };
};

export const mapDispatchToProps = dispatch => {
  return {
    DecrementCountDown: () => dispatch(DecrementCountDown()),
    hidePopUp: () => dispatch(hidePopUp()),
    logoutSessionFlush: (data, frm) => dispatch(logoutSessionFlush(data, frm))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TimerModal);
